import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChatRoutingModule } from './chat-routing.module';
import { ChatComponent } from './chat/chat.component';
import { ChatContentComponent } from './chat-content/chat-content.component';

import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [ChatComponent, ChatContentComponent],
  imports: [
    CommonModule,
    ChatRoutingModule,
    FormsModule,
    SharedModule,
    RouterModule,
    NgbModule,
    ReactiveFormsModule,
  ]
})
export class ChatModule { }
